import React from "react";
import {
  VStack,
  Input,
  Select,
  FormControl,
  FormLabel,
  Button,
} from "@chakra-ui/react";
import { DownloadIcon } from "@chakra-ui/icons";

function AddressInput({
  contractAddress,
  setContractAddress,
  networkInfo,
  networkIndex,
  setNetworkIndex,
  btnDisabled,
  fetchABI,
  isFetchingABI,
  bg,
}) {
  return (
    <VStack>
      <FormControl>
        <FormLabel>Contract Address</FormLabel>
        <Input
          value={contractAddress}
          onChange={(e) => setContractAddress(e.target.value)}
          placeholder="Address"
          aria-label="contract address"
          bg={bg}
        />
      </FormControl>
      <Select
        placeholder="Select Network"
        variant="filled"
        _hover={{ cursor: "pointer" }}
        value={networkIndex}
        onChange={(e) => setNetworkIndex(e.target.value)}
      >
        {networkInfo.map((network, i) => (
          <option value={i} key={i}>
            {network.name}
          </option>
        ))}
      </Select>
      <Button
        onClick={fetchABI}
        leftIcon={<DownloadIcon />}
        style={{ marginTop: "20px" }}
        colorScheme="blue"
        disabled={btnDisabled}
        isLoading={isFetchingABI}
        loadingText="Fetching Interface"
      >
        Fetch Solidity Interface
      </Button>
    </VStack>
  );
}

export default AddressInput;
